export const TUTORIAL_VIEW_STORAGE_KEY = '@doris:photo-tips-viewed'

export const isTutorialViewed = (): boolean => {
  const currentStorage = localStorage.getItem(TUTORIAL_VIEW_STORAGE_KEY)

  return currentStorage ? JSON.parse(currentStorage) : false
}

export const setTutorialAsViewed = (): void => localStorage.setItem(TUTORIAL_VIEW_STORAGE_KEY, JSON.stringify(true))
